import API from "../../api/Api.service";
import { lessonLanguage } from "../../utils/lessonLanguage";

const getMyLessonsData = async (data = {}) => {
  const res = await API.get("/my_courses", {
    ...data,
    params: { ...data.params, language: lessonLanguage(data.params?.language) },
  });
  return res.data;
};

const isEnrolledInCourse = async (courseId) => {
  const pageSize = 100;
  for (let page = 1; ; page += 1) {
    const enrollments = await getMyLessonsData({
      params: { page, page_size: pageSize },
    });
    if (
      enrollments.some((item) => String(item.course.id) === String(courseId))
    ) {
      return true;
    }
    if (enrollments.length < pageSize) return false;
  }
};

const MyLessonsService = {
  getMyLessonsData,
  isEnrolledInCourse,
};

export default MyLessonsService;
